export default __webpack_public_path__ + "static/media/Bracers of Courageous Souls.32b38252.jpg";